import { BlockProps } from "../../containers/Block";

export default function Unknown({ block }: BlockProps) {
  return (
    <div>
      Unknown Block Type: {block.blockType} - {block.blockId}
    </div>
  );
}
